import { Clock, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Props {
  formatLabel: string;
  message?: string | null;
  className?: string;
}

/**
 * Centered "Coming Soon" state shown instead of competitions for formats
 * that admins have disabled in Competition Type Settings.
 */
export default function ComingSoonFormat({ formatLabel, message, className }: Props) {
  return (
    <div className={`flex justify-center py-8 ${className ?? ""}`}>
      <Card className="w-full max-w-md text-center p-6 space-y-3 border-dashed">
        <div className="w-12 h-12 rounded-2xl bg-primary/15 text-primary flex items-center justify-center mx-auto">
          <Sparkles className="w-6 h-6" />
        </div>
        <div className="space-y-1.5">
          <h3 className="text-lg font-bold">{formatLabel}</h3>
          <div>
            <Badge variant="outline" className="gap-1 border-primary/40 text-primary">
              <Clock className="w-3 h-3" /> Coming Soon
            </Badge>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          {message?.trim() || "This competition format is launching soon. Stay tuned!"}
        </p>
      </Card>
    </div>
  );
}
